export const ACCESS_LOADING = "ACCESS_LOADING";

export const toggleAccessLoading = (loading) => (dispatch) => {
  return dispatch({
    type: ACCESS_LOADING,
    payload: loading,
  });
};
